const AppSettings = {
  cookieExpirationDays: 600,
  usePersonalInfoMessageCookieName: "id-auto-registration-allow-cookies",
  disableUsePersonalInfoMessageCookieName:
    "id-auto-registration-disable-cookies",
  recatchaKey: "6LcTqjYpAAAAAI_BgPkd2Adq4QQ3kOAfI3lCQEzo", // LOCAL TEST KEY
  // recatchaKey: '6LcukOIZAAAAAKb94J_swPnEtCVMXYTpPaOPU7Lv', // PROD KEY
  modalContainerId: "OIZAAAAAKb94JnEt",
  priceReport: 5600,
  currentPendingReportToken: "kOIRpTOv45v2vIPning6Lsmi",
  cacheUnFinishReportToken: "pTOv4ikOIRng6Lsmv2vIPni",
  paginationSize: 10,
  ticketName: "id-inscription-token",
  production: process.env.NODE_ENV === "production",
  reportKey: "idauto_inscripcion_",
};

export default AppSettings;
